<tan-loader [loading]="!hasProducts" [loadingText]="'<p>Getting Products</p>'">
</tan-loader>

<div class="row mt-3" *ngIf="hasProducts">
  <div class="col-sm-12">
    <tan-table [columnConfig]="columnConfig" [data]="products" [loading]="(productsLoading$ | async)"
      [error]="(productsError$ | async)" [iconClass]="iconClass" [totalPages]="pageCount" [itemCount]="itemCount"
      [currentPage]="currentPage" (onPageClick)="paginate($event)" (onClickViewItem)="viewItem($event)"
      (onClickRetry)="retry()" [canBulkEdit]="false" [page]="'products'" (searchTerm)="search($event)"
      (onClickSort)="sort($event)"></tan-table>
  </div>
</div>